export const dashboardManageCachePath = () => '/dashboard/manage-cache';
export const dashboardManageConsumersPath = () => '/dashboard/manage-consumers';
export const dashboardSubmitOrderLogPath = () => '/dashboard/submit-order-log';
export const dashboardVendorQuoteLogPath = () => '/dashboard/vendor-quote-log';
